'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useHasWPSession } from 'src/features/content/WPAdminFeatures/hooks';
import { useIsOnVercelUrl } from './hooks/useIsOnVercelUrl';
const ExperimentNavLazy = dynamic(() => import('./components/ExperimentNav.client').then(mod => ({
  default: mod.ExperimentNavClient
})), {
  ssr: false
});
type ExperimentNavProps = {
  staticExperimentName: string;
};
export function ExperimentNav(t0) {
  const $ = _c(2);
  const {
    staticExperimentName
  } = t0;
  const {
    hasWPSession
  } = useHasWPSession();
  const isOnVercel = useIsOnVercelUrl();
  const isDevelopmentEnvironment = process.env.NODE_ENV === "development";
  const shouldShowExperimentNav = isDevelopmentEnvironment || hasWPSession || isOnVercel;
  if (!shouldShowExperimentNav) {
    return null;
  }
  let t1;
  if ($[0] !== staticExperimentName) {
    t1 = <ExperimentNavLazy staticExperimentName={staticExperimentName} />;
    $[0] = staticExperimentName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}